// extracted by mini-css-extract-plugin
module.exports = {"hiddenTextWrap":"hiddenTextWrap__Ab0NRkMB59EiM","textToHide":"textToHide__vzZt-4f3Feetz","hiddenText":"hiddenText__WjfsBdtuZ3UN8"};